import Image, { StaticImageData } from 'next/image';
import goldPlanBackground from '../../../public/goldPlanBackground.svg';
import platinumPlanBackground from '../../../public/platinumPlanBackground.svg';
import silverPlanBackground from '../../../public/silverPlanBackground.svg';
import valuePlanBackground from '../../../public/valuePlanBackground.svg';
import comprehensiveBackground from '../../../public/comprehensivePlanBackground.svg';
import { getFormattedPrice } from '../MultiYearPlanPricing/utils';
import { TierType } from '@/types/tier';

type PerYearPlanType = {
  validity: string;
  pricing: {
    price: number;
  };
};
interface PlanBenefitsBannerProps {
  tier: TierType;
  perYearPlan: PerYearPlanType;
  pricePerYear?: boolean;
  status?: string;
}

interface planBackgroundImageMapType {
  [key: string]: StaticImageData;
}

const planBackgroundImageMap: planBackgroundImageMapType = {
  platinum: platinumPlanBackground,
  gold: goldPlanBackground,
  silver: silverPlanBackground,
  value: valuePlanBackground,
  comprehensive: comprehensiveBackground,
};

export const PlanBenefitsBanner = (props: PlanBenefitsBannerProps) => {
  const { tier, perYearPlan, pricePerYear = true, status } = props;

  const shouldShowPrice = () => {
    if (tier === 'comprehensive') {
      return false;
    }
    if (parseInt(perYearPlan.validity) !== 12) {
      return false;
    }
    if (
      perYearPlan.pricing.price === 0 ||
      perYearPlan.pricing.price === undefined ||
      perYearPlan.pricing.price === null
    ) {
      return false;
    }
    return true;
  };

  const tierStyle = `flex flex-row items-baseline justify-between absolute left-4 top-5 right-4 md:left-6 md:top-8 lg:left-10 lg:top-9 ${
    tier === 'platinum' ? 'text-[#FFFFFF]' : 'text-[#0D152A]'
  }`;

  const renderTitle = () => {
    if (status) {
      if (tier === 'comprehensive' && status === 'warranty') {
        return 'Warranty';
      } else if (tier === 'comprehensive') {
        return 'AMC';
      }
    }
    if (tier === 'value') {
      return `Base AMC`;
    }
    return `${tier} AMC`;
  };

  return (
    <div className="relative">
      <div>
        <Image
          src={planBackgroundImageMap[tier]}
          alt={tier + 'Benefits'}
          className="w-full h-24 md:h-40 rounded-tl-lg rounded-tr-lg"
          data-testid="tierBackground"
        />
      </div>
      <div className={tierStyle}>
        <p
          data-testid="tierName"
          className="font-bold text-lg leading-[1.6875rem] pb-0.5 md:text-[2rem] md:leading-[3rem] capitalize"
        >
          {renderTitle()}
        </p>
        {/* {shouldShowPrice() && (
          <p
            data-testid="tierPrice"
            className="font-bold text-base leading-[1.125rem] md:text-[2.125rem] md:leading-[3.1875rem] md:pr-4"
          >
            {getFormattedPrice(perYearPlan.pricing.price)}
            {pricePerYear && (
              <span className="font-normal text-[0.625rem] md:text-base leading-[1.125rem]">
                {'/ Year'}
              </span>
            )}
          </p>
        )} */}
      </div>
    </div>
  );
};
